"use strict";
export function nextCompletionAction(input) {
  if (input.hasNext) return "pushNext";
  if (input.hasGroupCallback) return "delegateToGroup";
  return "toDashboard";
}
